import { useEffect, useRef, useState } from "react"

const INACTIVITY_TIME = 15 * 60 * 1000 // 1 minuto para pruebas, ajusta según sea necesario

const useIdleTimer = (onLogout, isAuthenticated, inactivityTime = INACTIVITY_TIME) => {
  const timerRef = useRef(null)
  const [isInactive, setIsInactive] = useState(false)

  const resetGlobalTimer = () => {
    if (!isAuthenticated) return

    const expireTime = Date.now() + inactivityTime
    localStorage.setItem("expireTime", expireTime.toString())
    resetLocalTimer()
  }

  const resetLocalTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    const storedExpireTime = localStorage.getItem("expireTime")
    if (!storedExpireTime) return

    const expireTime = Number.parseInt(storedExpireTime, 10)
    const remainingTime = Math.max(0, expireTime - Date.now())

    timerRef.current = setTimeout(() => {
      if (isAuthenticated) {
        onLogout()
        localStorage.removeItem("expireTime")
        localStorage.setItem("logout", Date.now().toString())
      }
    }, remainingTime)
  }

  useEffect(() => {
    if (!isAuthenticated) {
      // Limpiar cualquier temporizador existente cuando se cierra sesión
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      localStorage.removeItem("expireTime")
      setIsInactive(false)
      return
    }

    const events = ["mousemove", "keydown", "scroll", "touchstart"]
    events.forEach((event) => window.addEventListener(event, resetGlobalTimer))

    const originalFetch = window.fetch
    window.fetch = (...args) => {
      resetGlobalTimer()
      return originalFetch.apply(window, args)
    }

    resetGlobalTimer() // Inicializar el temporizador cuando se inicia sesión

    const handleStorageChange = (event) => {
      if (event.key === "expireTime") {
        resetLocalTimer()
      }
      if (event.key === "logout") {
        onLogout()
      }
    }

    window.addEventListener("storage", handleStorageChange)

    return () => {
      events.forEach((event) => window.removeEventListener(event, resetGlobalTimer))
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      window.fetch = originalFetch
      window.removeEventListener("storage", handleStorageChange)
    }
  }, [isAuthenticated, onLogout, inactivityTime, resetGlobalTimer]) // Added resetGlobalTimer to dependencies

  return { isInactive }
}

export default useIdleTimer
